<template lang="">
    <v-row align="center"
          justify="center"
          >
        <v-col cols="12">
              
            <v-card
                class="mx-auto"
                max-width="800"
                outlined
            >
                
                <h1 style="text-align:center">
                    {{datos.codigo}}
                </h1>
            </v-card>


         </v-col>
    </v-row>
</template>
<script>

import {GetExeptions} from '../../../../../../services/exeptions/exeptions'

export default {
    
    mounted() {
        
        this.obtenerCodigo();

    },

    data(){

        return {

            datos:'',


        }
        
    },


    methods: {
        
        obtenerCodigo:function(){
            GetExeptions().then(response=>{
                this.datos = response;
            }).catch(errors=>{
                console.log('errors')
            });
        }

    },


}
</script>